import axios from '../config/api';

const SESSION_KEY = 'qh_funnel_session';
const SESSION_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export type FunnelEventType = 'menu_view' | 'cart_add' | 'checkout_started';

function loadSession(): { id: string; created: number } | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { id?: string; created?: number };
    if (!parsed.id || !parsed.created) return null;
    return { id: parsed.id, created: parsed.created };
  } catch {
    return null;
  }
}

/** Stable per-browser session for funnel distinct counts (rotates after 24h). */
export function getFunnelSessionId(): string {
  const existing = loadSession();
  const now = Date.now();
  if (existing && now - existing.created < SESSION_MAX_AGE_MS) {
    return existing.id;
  }
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `sess-${now}-${Math.random().toString(36).slice(2, 11)}`;
  localStorage.setItem(SESSION_KEY, JSON.stringify({ id, created: now }));
  return id;
}

/** Fire-and-forget; never blocks UX. */
export function trackFunnelEvent(eventType: FunnelEventType, cafeId: string): void {
  if (!cafeId) return;
  const session_id = getFunnelSessionId();
  axios
    .post('/api/analytics/events', { event_type: eventType, cafe_id: cafeId, session_id })
    .catch(() => {});
}
